import type { LucideIcon } from "lucide-react";
import { create } from "zustand";

export type BottomBarActionVariant = "primary" | "secondary" | "danger";

export interface BottomBarAction {
  id: string;
  label: string;
  icon?: LucideIcon;
  variant?: BottomBarActionVariant;
  disabled?: boolean;
  hidden?: boolean;
  onClick: () => void;
}

interface ShellBottomBarState {
  copilotOpen: boolean;
  setCopilotOpen: (open: boolean) => void;
  toggleCopilot: () => void;
}

export const useShellBottomBar = create<ShellBottomBarState>((set) => ({
  copilotOpen: false,
  setCopilotOpen: (copilotOpen) => set({ copilotOpen }),
  toggleCopilot: () => set((state) => ({ copilotOpen: !state.copilotOpen })),
}));
